import { styled } from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

import SwPageContent from "app/components/page-content";

export const RankTrackerPageContentWrapper = styled(SwPageContent)`
    .sw-layout-page {
        max-width: 1600px;
    }
`;

export const RankTrackerBannerWrapper = styled(Flex)`
    width: 100%;
    margin-bottom: 32px;
`;
